import { Component, Input } from "@angular/core";
import { Observable, of } from "rxjs";
import { Survey } from "../../../../shared/Models/read/Survey";
import { OUTSIDE_SURVEY_VAL_REMARKS } from "../config/outside-survey.magic-strings";

@Component({
  selector: "app-outside-survey-validate-remarks",
  templateUrl: "./outside-survey-validate-remarks.component.html",
  styleUrls: ["./outside-survey-validate-remarks.component.scss"],
})
export class OutsideSurveyValidateRemarksComponent {
  tabId = OUTSIDE_SURVEY_VAL_REMARKS;
  @Input() isAuthCanWrite: boolean;
  @Input() survey: Survey;

  constructor() {}

  save(checkValidity?: boolean): Observable<any> {
    return of(true);
  }
}
